export default "__VITE_ASSET__ddcefbba__"